import React from 'react';
import { Empty } from 'antd';
import { ModelImage } from './HeroGarment';
import styles from './modal.module.css';

function PeopleTable({ people, roleKey }) {
    if (!people?.length) return <Empty />;
    return (
        <table className={styles.teamTable}>
            <thead>
                <tr>
                    <th>Person</th>
                    <th>Role</th>
                    <th>Contact</th>
                </tr>
            </thead>
            <tbody>
                {people.map((user, index) => (
                    <tr key={user?.email || user?.name || index}>
                        <td>{user?.name || '—'}</td>
                        <td>{user?.[roleKey] || 'Not specified'}</td>
                        <td>{user?.email || '—'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default function TeamTab({ sku, onOpenTab }) {
    const shoot = sku?.shootSessionUserInfo || [];
    const inventory = sku?.inventorySessionUserInfo || [];
    return (
        <div className={styles.grid}>
            <div>
                {shoot.length ? (
                    shoot.map((info, index) => (
                        <div className={styles.card} key={`shoot-${info?.date}-${index}`}>
                            <h3 className={styles.cardTitle}>
                                Shoot team
                                <button type="button" className={styles.linkButton} onClick={() => onOpenTab('activity')}>
                                    View shoot activity
                                </button>
                            </h3>
                            <p className={styles.eventMeta}>{info?.date || ''}</p>
                            <PeopleTable people={info?.users} roleKey="designation" />
                        </div>
                    ))
                ) : (
                    <div className={styles.card}>
                        <h3 className={styles.cardTitle}>Shoot team</h3>
                        <Empty />
                    </div>
                )}
                {inventory.length ? (
                    inventory.map((info, index) => (
                        <div className={styles.card} key={`inv-${info?.sessionType}-${index}`}>
                            <h3 className={styles.cardTitle}>Inventory team</h3>
                            <p className={styles.eventMeta}>
                                {info?.sessionType || 'Session'}
                                {info?.history?.at ? ` · ${new Date(info.history.at).toLocaleString()}` : ''}
                            </p>
                            <PeopleTable people={info?.users} roleKey="designation" />
                        </div>
                    ))
                ) : (
                    <div className={styles.card}>
                        <h3 className={styles.cardTitle}>Inventory team</h3>
                        <Empty />
                    </div>
                )}
            </div>
            <div className={styles.card}>
                <h3 className={styles.cardTitle}>Shoot context</h3>
                <ModelImage sku={sku} width="100%" height="280px" />
            </div>
        </div>
    );
}
